import React from "react";
import { useFormContext } from "react-hook-form";

import { FormFieldStatus, Input } from "../../elements";
import { emailRegex, phoneRegex } from "../constants";
import { PersonalDataFormFieldsLabels, PersonalDataFormFieldsTypes } from "./types";

export interface PersonalDataFormFieldsProps {
  labels: PersonalDataFormFieldsLabels;
  isPhoneRequired?: boolean;
}

export function PersonalDataFormFields({ labels, isPhoneRequired }: PersonalDataFormFieldsProps) {
  const formMethods = useFormContext<PersonalDataFormFieldsTypes>();
  const { errors } = formMethods.formState;

  return (
    <div className="grid gap-4 grid-cols-12 w-full">
      <Input
        className="col-span-12 lg:col-span-6"
        label={labels.firstName}
        required
        optionalLabel={labels.optionalLabel}
        {...formMethods?.register("firstName", { required: labels.requiredFieldMessage })}
        message={errors.firstName?.message}
        status={FormFieldStatus.Error}
      />

      <Input
        className="col-span-12 lg:col-span-6"
        label={labels.lastName}
        required
        optionalLabel={labels.optionalLabel}
        {...formMethods?.register("lastName", { required: labels.requiredFieldMessage })}
        message={errors.lastName?.message}
        status={FormFieldStatus.Error}
      />

      <Input
        className="col-span-12 lg:col-span-6"
        label={labels.email}
        required
        optionalLabel={labels.optionalLabel}
        {...formMethods?.register("email", {
          required: labels.requiredFieldMessage,
          pattern: {
            value: emailRegex,
            message: labels.wrongEmailFormat,
          },
        })}
        message={errors.email?.message}
        status={FormFieldStatus.Error}
      />

      <Input
        className="col-span-12 lg:col-span-6"
        label={labels.phone}
        required={isPhoneRequired}
        optionalLabel={labels.optionalLabel}
        {...formMethods?.register("phone", {
          required: isPhoneRequired ? labels.requiredFieldMessage : undefined,
          pattern: {
            value: phoneRegex,
            message: labels.wrongPhoneFormat,
          },
        })}
        message={errors.phone?.message}
        status={FormFieldStatus.Error}
      />

      <Input
        className="col-span-12"
        label={labels.company}
        required
        optionalLabel={labels.optionalLabel}
        {...formMethods?.register("company", { required: labels.requiredFieldMessage })}
        message={errors.company?.message}
        status={FormFieldStatus.Error}
      />
    </div>
  );
}
